import axios from "axios";
import httpStatus from "http-status";
import { createContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import server from "../environment";

export const AuthContext = createContext({});

const client = axios.create({
  baseURL: `${server}/api/v1/users`,
});

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState({});
  const router = useNavigate();

  const handleRegister = async (name, username, password) => {
    const request = await client.post("/register", {
      name,
      username,
      password,
    });

    if (request.status === httpStatus.CREATED) {
      return request.data.message;
    }

    return "User registered successfully";
  };

  const handleLogin = async (username, password) => {
    const request = await client.post("/login", {
      username,
      password,
    });

    if (request.status === httpStatus.OK) {
      localStorage.setItem("token", request.data.token);
      router("/home");
    }
  };

  const getHistoryOfUser = async () => {
    const request = await client.get("/get_all_activity", {
      params: {
        token: localStorage.getItem("token"),
      },
    });

    return request.data;
  };

  const addToUserHistory = async (meetingCode) => {
    const request = await client.post("/add_to_activity", {
      token: localStorage.getItem("token"),
      meeting_code: meetingCode,
    });

    return request.data;
  };

  const data = useMemo(
    () => ({
      userData,
      setUserData,
      addToUserHistory,
      getHistoryOfUser,
      handleRegister,
      handleLogin,
    }),
    [userData]
  );

  return <AuthContext.Provider value={data}>{children}</AuthContext.Provider>;
};